import React from 'react'

// Which model answered. When the course's saved model has been retired the
// server answers with the default instead and says so (modelSubstituted).
export const ItemModel = ({ result }) => {
  if (!result.model) return null
  return (
    <span className="text-muted small mx-1" data-testid="ai-chat-model">
      <code>{result.model}</code>
      {result.modelSubstituted && result.requestedModel &&
        <span className="text-warning-emphasis"> (in place of retired <code>{result.requestedModel}</code>)</span>}
    </span>
  )
}
